import { AbstractClient } from './AbstractClient';
import {
  OwlResponse,
  PolicyCancellationRequest,
  PolicyCancellationUpdate,
} from '../../types';

export class CancelClient extends AbstractClient {
  fetch = this.createGetHandler<
    OwlResponse<PolicyCancellationRequest>,
    { args: { uuid: string } }
  >(({ uuid }) => `/${uuid}`);

  update = this.createPayloadHandler<
    OwlResponse<PolicyCancellationRequest>,
    { args: { uuid: string }; payload: Partial<PolicyCancellationUpdate> }
  >('PATCH', ({ uuid }) => `/${uuid}`);

  sign = this.createPayloadHandler<
    OwlResponse<PolicyCancellationRequest>,
    { args: { uuid: string }; payload: { signature: Blob } }
  >('POST', ({ uuid }) => `/${uuid}/sign`, {
    isFormData: true,
  });

  markReady = this.createPayloadHandler<
    OwlResponse<Record<string, never>>,
    { args: { uuid: string }; payload: Record<string, never> }
  >('POST', ({ uuid }) => `/${uuid}/mark-as-ready-for-carrier`);
}
